import React, { useEffect, useState, useRef } from 'react'
import Sidebar from '../components/Sidebar';
import { useLocation } from "react-router-dom";
import BackButton from '../components/BackButton';
import Card_1 from '../components/Card_1';

export default function SingleChannel() {
    const location = useLocation();
    const { playlist } = location.state || {};  // Get the playlist passed as state


    console.log(playlist)
    const [SelectedChannel, setSelectedChannel] = useState(0);

    return (
        <div>
            <Sidebar SelectedChannel={SelectedChannel}
                onChannelSelect={(index) => setSelectedChannel(index)}
            />

            <section className='body_section'>
                <BackButton/>
                <h3 className='bold mt-2' >{playlist?.name}</h3>

                <div className='video_card_grid' >
                    {playlist?.content?.map((video, index) => (
                       <Card_1 video={video} playlist={playlist}/>
                    ))}
                </div>

            </section>


        </div>
    )
}
